import { UPDATE_LOCALE_CASE } from './locale.types'

export const changeLocale = (locale) => ({
    type: UPDATE_LOCALE_CASE,
    payload: locale
})